import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import MainPageSkeleton from "../../../components/loaders/MainPageSkeleton";
import SwiperSlider from "../../../components/elements/slider/SwiperSlider";
import CategorySliderItem from "../categories/components/CategorySliderItem";
import VendorSliderItem from "../shops/components/VendorSliderItem";
import BannerSliderItem from "../components/BannerItem";
import Container from '@mui/material/Container';
import SingleCardProductHome from "../products/components/SingleCardProductHome";
import Title from "../../../components/elements/Title";
import MainSearchField from "../components/filters/MainSearchField";
import FrontFiltersLinks from "../components/filters/FrontFiltersLinks";
import {setStore} from "trim-redux";
import {addressQueryString} from "../../../../config/values";
import CharitiesSlider from "./charities/CharitiesSlider";

function MainPage({classes,industry}){
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setLoading(true);
        axios.get(`${defaultVariables.url}/front/main-page/${industry}${addressQueryString()}`,config)
            .then(response => {
                setData(response.data);
                if(response.data.new_vendors.length === 0){
                    navigation(`/${industry}/discover`)
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        loadData();
        setStore(({
            global_menu:industry
        }))
    },[industry]);



    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t(industry)}>
            <div className={classes.homeLayout}>
                {
                    !!loading ?
                        <Container maxWidth="xl" >
                            <MainPageSkeleton/>
                        </Container>
                        :
                        <>
                            <Container maxWidth="xl" >
                            <Grid container spacing={2} justify="center">
                                {
                                    ( data.categories?.length > 0) &&
                                    <Grid item size={12} >
                                        <SwiperSlider
                                            data={data.categories}
                                            spaceBetween={20}
                                            slidesPerView={3.5}
                                            showNavigation={true}
                                            showPagination={false}
                                            renderSlide={(category) => <CategorySliderItem category={category} industry={industry}/>}
                                            breakpoints={{
                                                370: {
                                                    slidesPerView: 4.5,
                                                },
                                                500: {
                                                    slidesPerView: 5.5,
                                                },
                                                768: {
                                                    slidesPerView: 7,
                                                    spaceBetween:20
                                                },
                                                992: {
                                                    slidesPerView: 9.5,
                                                    spaceBetween:30
                                                },
                                                1280: {
                                                    slidesPerView: 10,
                                                    spaceBetween:40
                                                },
                                            }}
                                        />
                                    </Grid>
                                }
                                <Grid item size={12} className="mt-10 mb-15">
                                    <Grid container spacing={2}>
                                        <Grid item size={{xs:12,sm:7,md:8}} style={{display:"flex",alignItems:'center',overflowX:"auto",padding:'5px 2px 10px'}} className="scroll-horizontal">
                                            <FrontFiltersLinks industry={industry}/>
                                        </Grid>
                                        <Grid item size={{xs:12,sm:5,md:4}} >
                                            <MainSearchField industry={industry}/>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {
                                    data.popular_vendors?.length > 0 &&
                                    <Grid item size={12} className="mb-30">
                                        <Title className="mb-15" align='left' color='text'>{t('popular')} {t(industry)}</Title>
                                        <SwiperSlider
                                            data={data.popular_vendors}
                                            spaceBetween={20}
                                            slidesPerView={1.3}
                                            showNavigation={true}
                                            renderSlide={(vendor) => <VendorSliderItem vendor={vendor} industry={industry}/>}
                                            breakpoints={{
                                                450: { slidesPerView: 1.3 },
                                                576: { slidesPerView: 2.2 },
                                                768: { slidesPerView: 2.5 },
                                                992: { slidesPerView: 3.5 },
                                                1280: { slidesPerView: 4.3 },
                                            }}
                                        />
                                    </Grid>
                                }
                                {
                                    data.banners?.length > 0 &&
                                    <Grid item size={12} className="mb-30">
                                        <SwiperSlider
                                            data={data.banners}
                                            spaceBetween={20}
                                            slidesPerView={1}
                                            showNavigation={false}
                                            showPagination={false}
                                            //disablePaginationOnMobile={true}
                                            //disableNavigationOnMobile={true}
                                            autoplay={true}
                                            autoplaySpeed={3000}
                                            loop={true}
                                            renderSlide={(banner) => <BannerSliderItem banner={banner} />}
                                        />
                                    </Grid>
                                }
                            {/*    <Grid item size={12} className="mb-30">
                                    <CharitiesSlider/>
                                </Grid>*/}


                                {
                                    data.economic_vendors?.length > 0 &&
                                    <Grid item size={12} className="mb-30">
                                        <Title className="mb-15" align='left' color='text'>{t('economic')} {t(industry)}</Title>
                                        <SwiperSlider
                                            data={data.economic_vendors}
                                            spaceBetween={20}
                                            slidesPerView={1.3}
                                            showNavigation={true}
                                            renderSlide={(vendor) => <VendorSliderItem vendor={vendor} industry={industry}/>}
                                            breakpoints={{
                                                450: { slidesPerView: 1.3 },
                                                576: { slidesPerView: 2.2 },
                                                768: { slidesPerView: 2.5 },
                                                992: { slidesPerView: 3.5 },
                                                1280: { slidesPerView: 4.3 },
                                            }}
                                        />
                                    </Grid>
                                }
                                {
                                    data.new_vendors?.length > 0 &&
                                    <Grid item size={12} className="mb-30">
                                        <Title className="mb-15" align='left' color='text'>{t('new')} {t(industry)}</Title>
                                        <SwiperSlider
                                            data={data.new_vendors}
                                            spaceBetween={20}
                                            slidesPerView={1.3}
                                            showNavigation={true}
                                            renderSlide={(vendor) => <VendorSliderItem vendor={vendor} industry={industry}/>}
                                            breakpoints={{
                                                450: { slidesPerView: 1.3 },
                                                576: { slidesPerView: 2.2 },
                                                768: { slidesPerView: 2.5 },
                                                992: { slidesPerView: 3.5 },
                                                1280: { slidesPerView: 4.3 },
                                            }}
                                        />
                                    </Grid>
                                }
                            </Grid>
                            </Container>
                            <>
                                {
                                    data.discounted_products.length > 0 &&
                                    <section className='pink-container'>
                                        <Container maxWidth="xl" >
                                            <Title className="mb-15" align='left' color='text'>{industry === "restaurants" ? t('discountedFood') : t('discountedProduct')}</Title>
                                            <Grid container spacing={2}>
                                                {
                                                    data.discounted_products.map((product,index) =>(
                                                        <Grid item size={{xs:12,sm:6,lg:3}} key={index}>
                                                            <SingleCardProductHome product={product}/>
                                                        </Grid>
                                                    ))
                                                }
                                            </Grid>
                                        </Container>
                                    </section>
                                }
                            </>

                        </>

                }
        </div>
        </AppAnimate>
    );
}
export default withStyles(Styles)(MainPage);
